<script lang="ts">
export default {
    name: "rightHeader",
};
</script>

<script setup lang="ts">
import axios from 'axios';
import { store } from "@/store"
import { onMounted, onBeforeUnmount } from 'vue';
import Notice from "./notice.vue"
import { getAssetsFile } from '@/utils/pub-use'
import router from "@/router";

interface WeatherQuery {
    adcode?: string,
    city?: string,
    humidity?: string,
    humidity_float?: string,
    province?: string,
    reporttime?: string,
    temperature?: string,
    temperature_float?: string,
    weather?: string,
    winddirection?: string,
    windpower?: string,
}
const weatherValue = reactive<WeatherQuery>({});
const city = ref()
const weather = () => {
    axios.get('https://restapi.amap.com/v3/weather/weatherInfo', {
        params: {
            city: city.value, //你的城市
            key: 'efcdb0d982c73ca59396f1aa26fa0040',//高德api创建项目获取的key
            extensions: 'base'
        }
    }).then(res => {
        // console.log(res)
        if (res.status === 200 && Array.isArray(res.data.lives) && res.data.lives.length) {
            Object.assign(weatherValue, res.data.lives[0]);
        }
    })
}

const timer = ref()
const moreDate = ref()
function nowDate() {
    var time = new Date(new Date().getTime()); //获取到当前时间戳); //创建一个日期对象
    var year = time.getFullYear(); // 年
    var month = (time.getMonth() + 1).toString().padStart(2, '0'); // 月
    var date = time.getDate().toString().padStart(2, '0'); // 日
    moreDate.value = `${year}年${month}月${date}日`
}

const moreTime = ref()
function nowTime() {
    const time = new Date()
    const hour = complement(time.getHours())
    const minute = complement(time.getMinutes())
    const second = complement(time.getSeconds())
    moreTime.value = `${hour}:${minute}:${second}`
}

//当时间为个位数的时候，在数字前加0
const complement = (value: number): string => {
    return value < 10 ? `0${value}` : value.toString()
}

const backBtn = () => {
    console.log(window.location.hostname)
    // window.location.href = window.location.href;
    window.location.href = 'https://fh.zxhkuav.cn/#/dashboard';
    // window.location.replace("https://fh.zxhkuav.cn/dashboard")
}

watch(() => store.informationListStore.informationStore().organizationData.cityCode, async (data, oldVal) => {
    console.log(data)
    if (data && !store.informationListStore.informationStore().organizationData.areaCode) {
        city.value = data
        weather()
    }
}, {
    immediate: true,
    deep: true
})

watch(() => store.informationListStore.informationStore().organizationData.areaCode, async (data, oldVal) => {
    console.log(data)
    if (data) {
        city.value = data
        weather()
    }
}, {
    immediate: true,
    deep: true
})

onMounted(() => {
    weather()
    timer.value = setInterval(() => {
        nowDate()
        nowTime()
    }, 1000)
})

//取消定时器
onBeforeUnmount(() => {
    clearInterval(timer.value) //清除定时器
})
</script>

<template>
    <div class="right-header">
        <div class="headerBox">
            <p style="display: flex;align-items: center;height: 2vh;font-size: 1.125rem;">
                <span>{{ weatherValue.city }}</span>
                <span style="color: #F3D127;display: inline-block;margin: 0 10px;">|</span>
                <span style="font-size: 1rem;font-weight: 400;">
                    <span style="display: block;">{{ moreDate }}</span>
                    <span style="display: block;">{{ moreTime }}</span>
                </span>
            </p>
            <div class="weater-box">
                <div style="display: flex;align-items: center;">
                    <p class="weater">
                        <img :src="getAssetsFile('weather-img/' + weatherValue.weather + '.png')" alt="">
                    </p>
                    <p style="font-size: 1rem;">{{ weatherValue.weather }}</p>
                </div>
                <div style="font-weight: 400;font-size: 1rem;color: #87DEFF;">风力：{{ weatherValue.windpower }}级</div>
            </div>
            <!-- <p class="houtai">
                <img src="@/assets/images/houtai.png" alt="">
            </p> -->
            <p class="back" @click="backBtn">
                <img src="@/assets/images/back-img.png" alt="">
            </p>
        </div>
        <Notice />
    </div>
</template>

<style scoped lang="scss">
.right-header {
    width: 18vw;

    .headerBox {
        position: relative;
        width: 18.6vw;
        height: 8.2vh;
        display: flex;

        // justify-content: space-around;
        p {
            margin-top: 1.5rem;
            font-family: Segoe UI, Segoe UI;
            font-weight: bold;
            font-size: 1.25rem;
            color: #CDD6E3;
        }

        .line {
            color: #f3d127;
        }

        .weater-box {
            margin-top: 0.5rem;

            p {
                margin-top: 0;
            }

            .weater {
                width: 2.1vw;
                height: 3.2vh;
                margin: 0 .3125rem;

                // background-color: #CDD6E3;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .houtai {
            position: absolute;
            top: -10px;
            right: 3.5rem;
            width: 2vw;
            height: 35px;
            cursor: pointer;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .back {
            position: absolute;
            top: 0px;
            right: 2rem;
            width: 1.2vw;
            height: 22px;
            cursor: pointer;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>
